const React = require('react');
const { useState,useEffect } = require('react');
const T = require('prop-types');

const { default: Popover } = require('@mui/material/Popover');
const { default: Button } = require('@mui/material/Button');
const { default: IconButton } = require('@mui/material/IconButton');

const { default: Picker } = require('emoji-picker-react');

const Emoji = require('./Emoji');
const { default: CancelIcon } = require('@mui/icons-material/Cancel');
const { default: styled } = require('styled-components');

const internals = {};

const EmojiPicker = (props) => {

    const {
        onChange,
        label,
        value
    } = props;

    const {
        StyledArrow,
        StyledPopover
    } = internals;

    const [anchorRef, setAnchorRef] = useState(null);
    const [emojiSymbol, setEmojiSymbol] = useState('');

    const open = Boolean(anchorRef);

    useEffect(() => {

        setEmojiSymbol(value);
    }, [value]);

    const handleClick = (event) => {

        setAnchorRef(event.currentTarget);
    };

    const handleClose = () => {

        setAnchorRef(null);
    };

    const onEmojiClick = (emojiObject) => {

        const selectedEmojiSymbol = emojiObject.emoji;

        onChange(selectedEmojiSymbol);
        setEmojiSymbol(selectedEmojiSymbol);

        handleClose();
    };

    const onClearBtnCLick = (event) => {

        onChange('');
        setEmojiSymbol('');
    };

    return (
        <div
            style={{
                width: '100%',
                height: 56,
                marginLeft: emojiSymbol ? 4 : 0,
                display: 'flex',
                flexFlow: 'row nowrap',
                alignItems: 'center',
                gap: 18
            }}
        >
            {!emojiSymbol && <>
                <Button
                    variant='contained'
                    color='primary'
                    size='small'
                    onClick={handleClick}
                    style={{ maxHeight: 36 }}
                >
                    Select
                </Button>
                <div>{label}</div>
            </>}
            {emojiSymbol && <div
                style={{
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    alignItems: 'center',
                    gap: 29
                }}
            >
                <Emoji size={46} symbol={emojiSymbol} />
                <div style={{ marginLeft: 10 }}>{label}</div>
                <IconButton onClick={onClearBtnCLick}>
                    <CancelIcon />
                </IconButton>
            </div>}
            <StyledPopover
                open={open}
                anchorEl={anchorRef}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                onClose={handleClose}
            >
                <StyledArrow />
                <Picker
                    onEmojiClick={onEmojiClick}
                    disableAutoFocus={true}
                    disableSkinTonePicker={false}
                    groupVisibility={{
                        flags: false
                    }}
                    emojiStyle='native'
                />
            </StyledPopover>
        </div>
    );
};

EmojiPicker.propTypes = {
    onChange: T.func,
    label: T.string,
    value: T.string
};

module.exports = EmojiPicker;

internals.StyledArrow = styled.span`
    position: absolute;
    font-size: 7px;
    width: 3em;
    height: 3em;
    &::before {
        content: '';
        margin: auto;
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
    }
`;

internals.StyledPopover = styled(Popover)`
    z-index: ${({ theme }) => theme.zIndex?.modal || 1300};

    &[x-placement*='top'] {
        ${internals.StyledArrow} {
            bottom: 0;
            left: 0;
            margin-bottom: -0.9em;
            width: 3em;
            height: 1em;

            &::before {
                border-width: 1em 1em 0 1em;
                border-color: ${({ theme }) => `${theme.palette.background.paper} transparent transparent transparent`};
            }
        }
    }
`;
